const inputCls =
  "w-full border border-line bg-asphalt px-4 py-3 text-sm text-bright placeholder:text-dim outline-none transition-colors duration-300 focus:border-hazard";

export function TextField({ label, name, value, onChange, type = "text", required = false, placeholder = "", testId }) {
  return (
    <label className="block">
      <span className="mb-1.5 block font-mono text-[11px] uppercase tracking-[0.2em] text-[#9CA3AF]">
        {label} {required && <span className="text-hazard">*</span>}
      </span>
      <input
        data-testid={testId}
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        placeholder={placeholder}
        className={inputCls}
      />
    </label>
  );
}

export function SelectField({ label, name, value, onChange, options, required = false, testId }) {
  return (
    <label className="block">
      <span className="mb-1.5 block font-mono text-[11px] uppercase tracking-[0.2em] text-[#9CA3AF]">
        {label} {required && <span className="text-hazard">*</span>}
      </span>
      <select data-testid={testId} name={name} value={value} onChange={onChange} required={required} className={inputCls}>
        <option value="" disabled>
          Select…
        </option>
        {options.map((o) => (
          <option key={o} value={o}>
            {o}
          </option>
        ))}
      </select>
    </label>
  );
}

export function TextAreaField({ label, name, value, onChange, placeholder = "", rows = 4, testId }) {
  return (
    <label className="block">
      <span className="mb-1.5 block font-mono text-[11px] uppercase tracking-[0.2em] text-[#9CA3AF]">{label}</span>
      <textarea
        data-testid={testId}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows}
        className={`${inputCls} resize-none`}
      />
    </label>
  );
}
